
;(function () {
  var TRYON_FLAG_KEY = 'dressx_try_on_completed';
  var EMAIL_FLAG_KEY = 'dressx_email_submitted_pending';
  var LOGIN_FLAG_KEY = 'dressx_login_pending';

  function amp() {
    return (window.amplitude && typeof window.amplitude.track === 'function') ? window.amplitude : null;
  }

  var STOREFRONT_VERSION = '1.0.0';

  function track(name, props) {
    var a = amp();
    if (!a) return;
    var payload = props || {};
    if (payload.version === undefined) payload.version = STOREFRONT_VERSION;
    a.track(name, payload);
  }

  function currentTemplate() {
    try {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      var pageType = meta && meta.page && meta.page.pageType;
      if (!pageType && window.meta && window.meta.page) pageType = window.meta.page.pageType;
      if (pageType) return String(pageType).toLowerCase();
    } catch (e) {}
    var body = document.body;
    if (body) {
      var cls = String(body.className || '');
      var m = cls.match(/(?:^|\s)main--([a-z0-9_-]+)/i) || cls.match(/(?:^|\s)template-([a-z0-9_-]+)/i);
      if (m) return m[1].toLowerCase();
    }
    var path = String(location.pathname || '').toLowerCase();
    if (path.indexOf('/products/') !== -1) return 'product';
    if (path.indexOf('/collections/') !== -1) return 'collection';
    if (path.indexOf('/cart') !== -1) return 'cart';
    if (path.indexOf('/search') !== -1) return 'search';
    if (path.indexOf('/account') !== -1) return 'account';
    if (path === '/' || path === '') return 'index';
    return '';
  }

  function isSignedIn() {
    if (typeof window.__DRESSX_SIGNED_IN === 'boolean') return window.__DRESSX_SIGNED_IN;

    return !!document.querySelector('a[href*="/account/logout"]');
  }

  function hasCompletedTryOn() {
    try { return sessionStorage.getItem(TRYON_FLAG_KEY) === '1'; } catch (e) { return false; }
  }

  function params() {
    return (typeof window.__DRESSX_TRYON_PARAMS === 'object' && window.__DRESSX_TRYON_PARAMS) || {};
  }

  function getCurrency(fallback) {
    if (fallback) return String(fallback);
    try {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        return String(window.Shopify.currency.active);
      }
    } catch (e) {}
    try {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      if (meta && meta.currency) return String(meta.currency);
    } catch (e) {}
    try {
      if (window.__DRESSX_STORE_CURRENCY) return String(window.__DRESSX_STORE_CURRENCY);
    } catch (e) {}
    return '';
  }

  function money(cents) {
    if (cents == null || cents === '') return null;
    var n = Number(cents);
    if (isNaN(n)) return null;
    return n / 100;
  }

  function productProps(extra) {
    var p = params();
    var out = {};
    if (p.id != null) out.id = p.id;
    if (p.sku) out.sku = p.sku;
    if (p.price != null) {
      out.price = p.price;
      var curr = getCurrency(p.currency);
      if (curr) out.currency = curr;
    }
    if (p.product_category) out.product_category = p.product_category;
    if (p.product_brand) out.product_brand = p.product_brand;
    if (Array.isArray(p.product_collections) && p.product_collections.length) {
      out.product_collections = p.product_collections;
    }
    if (extra) { for (var k in extra) { if (Object.prototype.hasOwnProperty.call(extra, k)) out[k] = extra[k]; } }
    return out;
  }

  var template = currentTemplate();

  function firePageLoadEvents() {
    if (window.__DRESSX_PAGE_LOAD_EVENTS_SENT) return;
    window.__DRESSX_PAGE_LOAD_EVENTS_SENT = true;

    track('page_view', {
      page_name: template || 'page',
      signin: isSignedIn()
    });

    if (template.indexOf('product') === 0) {
      var source = 'direct';
      try {
        var ref = typeof document.referrer === 'string' ? document.referrer : '';
        if (ref) {
          var u = new URL(ref);
          if (u.origin === window.location.origin) {
            var path = (u.pathname || '').toLowerCase();
            if (path.indexOf('/search') !== -1) source = 'search';
            else if (path.indexOf('/cart') !== -1) source = 'cart';
            else if (path.indexOf('/collections/') !== -1) source = 'collection';
            else if (path.indexOf('wishlist') !== -1) source = 'wishlist';
            else if (path.indexOf('/account') !== -1) source = 'account';
            else if (path === '/' || path === '') source = 'home';
            else source = 'other';
          } else source = 'external';
        }
      } catch (e) {}

      track('product_viewed', productProps({
        signin: isSignedIn(),
        try_on_completed: hasCompletedTryOn(),
        source: source
      }));
    }

    if (template === 'cart') {
      track('cart_viewed', {
        signin: isSignedIn(),
        try_on_completed: hasCompletedTryOn()
      });
    }

    try {
      if (sessionStorage.getItem(EMAIL_FLAG_KEY) === '1') {
        sessionStorage.removeItem(EMAIL_FLAG_KEY);
        track('email_submitted', { description: 'user submitted email' });
      }
    } catch (e) {}

    try {
      if (sessionStorage.getItem(LOGIN_FLAG_KEY) === '1' && isSignedIn()) {
        sessionStorage.removeItem(LOGIN_FLAG_KEY);
        track('login', { status: 'login successful' });
      }
    } catch (e) {}
  }

  // Widget sets window.__DRESSX_TRYON_ATC_UNTIL just before /cart/add.
  // Consume on the first added_to_cart so a later PDP add is false.
  function consumeTryOnProvided() {
    var until = 0;
    try { until = Number(window.__DRESSX_TRYON_ATC_UNTIL) || 0; } catch (e) {}
    try { window.__DRESSX_TRYON_ATC_UNTIL = 0; } catch (e) {}
    return until > Date.now();
  }

  function trackCartAdd(payload, storedCollections) {
    var item = null;
    if (payload && Array.isArray(payload.items) && payload.items.length) item = payload.items[0];
    else if (payload && payload.id) item = payload;
    if (!item) return;
    var props = {
      signin: isSignedIn(),
      try_on_completed: hasCompletedTryOn(),
      try_on_provided: consumeTryOnProvided()
    };
    if (item.id != null) props.id = item.id;
    if (item.sku) props.sku = item.sku;
    var price = money(item.price);
    if (price != null) {
      props.price = price;
      var curr = getCurrency((payload && payload.cart && payload.cart.currency) || item.currency);
      if (curr) props.currency = curr;
    }
    if (item.product_type) props.product_category = item.product_type;
    if (item.vendor) props.product_brand = item.vendor;
    var p = params();
    if (Array.isArray(p.product_collections) && p.product_collections.length) {
      props.product_collections = p.product_collections;
    } else if (Array.isArray(storedCollections) && storedCollections.length) {
      props.product_collections = storedCollections;
    }
    clearPendingCartAdd();
    track('added_to_cart', props);
  }

  var PENDING_ADD_KEY = '__dx_pending_cart_add';

  function clearPendingCartAdd() {
    try { sessionStorage.removeItem(PENDING_ADD_KEY); } catch (e) {}
  }

  function stashPendingCartAdd(form) {
    try {
      var data = new FormData(form);
      var id = data.get('id');
      if (!id) return;
      var p = params();
      sessionStorage.setItem(PENDING_ADD_KEY, JSON.stringify({
        id: String(id),
        at: Date.now(),
        collections: Array.isArray(p.product_collections) ? p.product_collections : []
      }));
    } catch (e) {}
  }

  function flushPendingCartAdd() {
    var raw = null;
    try { raw = sessionStorage.getItem(PENDING_ADD_KEY); } catch (e) {}
    if (!raw) return;
    clearPendingCartAdd();
    var pending = null;
    try { pending = JSON.parse(raw); } catch (e) {}
    if (!pending || !pending.id || (Date.now() - pending.at) > 60000) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root.replace(/\/?$/, '/') + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var item = null;
        for (var i = 0; i < items.length; i++) {
          if (String(items[i].variant_id || items[i].id) === pending.id) { item = items[i]; break; }
        }
        if (item) trackCartAdd({ items: [item], cart: cart }, pending.collections);
      })
      .catch(function () {});
  }

  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
      var isAdd = url.indexOf('/cart/add') !== -1;
      var call = nativeFetch.apply(this, arguments);
      if (!isAdd) return call;
      return call.then(function (res) {
        try {
          res.clone().json().then(trackCartAdd).catch(function () {});
        } catch (e) {}
        return res;
      });
    };
  }

  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    try { this.__dxCartAdd = String(url || '').indexOf('/cart/add') !== -1; } catch (e) {}
    return nativeOpen.apply(this, arguments);
  };
  var nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__dxCartAdd) {
      this.addEventListener('load', function () {
        try { trackCartAdd(JSON.parse(this.responseText)); } catch (e) {}
      });
    }
    return nativeSend.apply(this, arguments);
  };

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('cart') === -1) return;
    if (form.action.indexOf('/cart/add') !== -1) stashPendingCartAdd(form);
    var submitter = e.submitter;
    var isCheckout = submitter && (submitter.name === 'checkout' || submitter.getAttribute('name') === 'checkout');
    if (!isCheckout) return;

    e.preventDefault();
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var checkoutUrl = root.replace(/\/?$/, '') + '/checkout';
    var done = false;
    function go() { if (done) return; done = true; window.location.href = checkoutUrl; }
    setTimeout(go, 1500);

    try {
      fetch(root.replace(/\/?$/, '/') + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var first = (cart.items || [])[0];
          var props = { try_on_completed: hasCompletedTryOn() };
          if (first) {
            if (first.id != null) props.id = first.id;
            if (first.sku) props.sku = first.sku;
            var price = money(first.price);
            if (price != null) {
              props.price = price;
              var curr = getCurrency(cart && cart.currency);
              if (curr) props.currency = curr;
            }
            if (first.product_type) props.product_category = first.product_type;
            if (first.vendor) props.product_brand = first.vendor;
          }
          track('checkout_started', props);
          setTimeout(go, 150);
        })
        .catch(function () {
          track('checkout_started', { try_on_completed: hasCompletedTryOn() });
          setTimeout(go, 150);
        });
    } catch (err) {
      track('checkout_started', { try_on_completed: hasCompletedTryOn() });
      go();
    }
  }, true);

  if (template.indexOf('product') === 0) {

    var SIZE_LABEL_RE = new RegExp(
      '^(' +
        'size|sizes|' +
        'taille|tailles|' +
        'talla|tallas|' +
        'tamanho|tamanhos|' +
        'gr[o\u00f6]sse|gr[o\u00f6]ssen|gr\u00f6\u00dfe|' +
        'misura|misure|' +
        '\u0440\u0430\u0437\u043c\u0435\u0440|\u0440\u0430\u0437\u043c\u0435\u0440\u044b|' +
        '\u30b5\u30a4\u30ba|' +
        '\uce58\uc218|' +
        '\u5c3a\u7801|\u5c3a\u5bf8' +
      ')(?![a-z])',
      'i'
    );

    function currentVariantId() {
      try {
        var hidden = document.querySelector('form[action*="/cart/add"] [name="id"]');
        if (hidden && hidden.value) return String(hidden.value);
      } catch (e) {}
      try {
        var fromUrl = new URLSearchParams(window.location.search).get('variant');
        if (fromUrl) return String(fromUrl);
      } catch (e) {}
      var p = params();
      if (p.variant_id != null && p.variant_id !== '') return String(p.variant_id);
      return '';
    }

    function isSizeHeading(text) {
      var t = String(text || '').toLowerCase().replace(/[:\s]+$/g, '').trim();
      if (!t) return false;
      return SIZE_LABEL_RE.test(t);
    }

    function optionHeadingText(wrap) {
      if (!wrap) return '';
      var heading = wrap.querySelector('.ProductForm__Label, legend');
      return heading ? String(heading.textContent || '').replace(/\s+/g, ' ').trim() : '';
    }

    function isSizeControl(el) {
      if (!el || !el.closest) return false;
      var tag = String(el.tagName || '').toLowerCase();
      if (tag !== 'input' && tag !== 'select') return false;
      if (el.classList && el.classList.contains('SizeSwatch__Radio')) return true;
      if (el.closest('.SizeSwatchList')) return true;
      var option = el.closest('.ProductForm__Option');
      if (option && isSizeHeading(optionHeadingText(option))) return true;
      var wrap = el.closest('[data-option-index], fieldset');
      if (wrap && isSizeHeading(optionHeadingText(wrap))) return true;
      if (el.hasAttribute && el.hasAttribute('js-product-option-selector')) {
        return isSizeHeading(optionHeadingText(el.closest('.ProductForm__Option, fieldset, .selector-wrapper')));
      }
      return false;
    }

    function selectedSizeValue(el) {
      return (el && (el.value || el.getAttribute('value'))) || '';
    }

    function checkedSizeInput() {
      return document.querySelector('.SizeSwatch__Radio:checked')
        || document.querySelector('.SizeSwatchList input[type="radio"]:checked');
    }

    function productOptionNames() {
      var names = [];
      try {
        var prod = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
        var opts = prod && prod.options;
        if (Array.isArray(opts)) {
          for (var i = 0; i < opts.length; i++) {
            var opt = opts[i];
            if (typeof opt === 'string') names.push(opt);
            else if (opt && opt.name) names.push(String(opt.name));
          }
        }
      } catch (e) {}
      if (names.length) return names;
      var headings = document.querySelectorAll(
        '.ProductForm__Option--labelled > .ProductForm__Label, .ProductForm__Option > legend'
      );
      for (var j = 0; j < headings.length; j++) {
        names.push(String(headings[j].textContent || '').replace(/\s+/g, ' ').trim());
      }
      return names;
    }

    function sizeFromVariant(variant, previous) {
      if (!variant) return '';
      var names = productOptionNames();
      var keys = ['option1', 'option2', 'option3'];
      var i;
      for (i = 0; i < keys.length; i++) {
        if (!isSizeHeading(names[i] || '')) continue;
        if (variant[keys[i]]) return String(variant[keys[i]]);
      }
      if (previous) {
        for (i = 0; i < keys.length; i++) {
          var nv = variant[keys[i]] || '';
          var pv = previous[keys[i]] || '';
          if (!nv || nv === pv) continue;
          if (names[i] && !isSizeHeading(names[i])) continue;
          if (!names[i] && !document.querySelector('.SizeSwatch__Radio[value="' + String(nv).replace(/"/g, '\\"') + '"]')) {
            continue;
          }
          return String(nv);
        }
      }
      return selectedSizeValue(checkedSizeInput());
    }

    function sizeOptionChanged(variant, previous) {
      if (!variant || !previous) return !!sizeFromVariant(variant, previous);
      var names = productOptionNames();
      var keys = ['option1', 'option2', 'option3'];
      for (var i = 0; i < keys.length; i++) {
        var nv = variant[keys[i]] || '';
        var pv = previous[keys[i]] || '';
        if (!nv || nv === pv) continue;
        if (names[i]) return isSizeHeading(names[i]);
        return !!document.querySelector('.SizeSwatch__Radio[value="' + String(nv).replace(/"/g, '\\"') + '"]');
      }
      return false;
    }

    function sizeProps(input, resolvedVariantId) {
      var p = params();
      var out = { try_on_completed: hasCompletedTryOn() };
      var variantId = (input && input.getAttribute('data-variant-id'))
        || resolvedVariantId
        || currentVariantId()
        || (p.variant_id != null ? p.variant_id : '');
      if (variantId) out.id = variantId;
      if (p.sku) out.sku = p.sku;
      if (p.price != null) {
        out.price = p.price;
        var curr = getCurrency(p.currency);
        if (curr) out.currency = curr;
      }
      if (p.product_category) out.product_category = p.product_category;
      if (p.product_brand) out.product_brand = p.product_brand;
      if (Array.isArray(p.product_collections) && p.product_collections.length) {
        out.product_collections = p.product_collections;
      }
      return out;
    }

    var lastSizeKey = '';
    var lastSizeAt = 0;
    function fireSizeSelected(input, sizeValue, resolvedVariantId) {
      var size = sizeValue || selectedSizeValue(input) || selectedSizeValue(checkedSizeInput());
      if (!size) return;
      var now = Date.now();
      var key = String(size);
      if (key === lastSizeKey && (now - lastSizeAt) < 400) return;
      lastSizeKey = key;
      lastSizeAt = now;

      var before = currentVariantId();
      var givenId = resolvedVariantId ? String(resolvedVariantId) : '';
      var attempts = 0;
      (function settle() {
        var current = givenId || currentVariantId();
        if (givenId || (current && current !== before) || attempts >= 20) {
          var props = sizeProps(input, current || before);
          props.size = size;
          track('size_selected', props);
          return;
        }
        attempts += 1;
        setTimeout(settle, 50);
      })();
    }

    document.addEventListener('change', function (e) {
      if (!isSizeControl(e.target)) return;
      fireSizeSelected(e.target);
    }, true);

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var label = t.closest('label[for], .SizeSwatch');
      var input = null;
      if (label && label.getAttribute && label.getAttribute('for')) {
        input = document.getElementById(label.getAttribute('for'));
      }
      if (!input) input = t.closest('input.SizeSwatch__Radio, .SizeSwatchList input');
      if (!isSizeControl(input)) return;
      fireSizeSelected(input);
    }, true);

    document.addEventListener('variant:changed', function (e) {
      var detail = (e && e.detail) || {};
      var variant = detail.variant;
      var previous = detail.previousVariant;
      if (!sizeOptionChanged(variant, previous)) return;
      var size = sizeFromVariant(variant, previous);
      var input = checkedSizeInput();
      var variantId = variant && variant.id != null ? String(variant.id) : '';
      fireSizeSelected(input, size, variantId);
    });
  }

  function searchQuery() {
    var input = document.querySelector('.Search__Input')
      || document.getElementById('header-search')
      || document.querySelector('form[role="search"] input[type="search"]')
      || document.querySelector('input[type="search"][name="q"]');
    return (input && input.value) ? input.value.trim() : '';
  }

  function fireSearchOpened(el) {
    var inDrawer = !!(el && el.closest && (el.closest('#SearchDrawer') || el.closest('[class*="drawer"], [class*="Drawer"]')));
    track('search_opened', {
      signin: isSignedIn(),
      query: searchQuery(),
      source: inDrawer ? 'drawer' : 'header'
    });
  }

  var SEARCH_TRIGGERS = '[data-action="toggle-search"], [js-search-drawer-open], .btn--search, a[href$="/search"], a[href*="/search?"]';

  document.addEventListener('click', function (e) {
    var trigger = e.target && e.target.closest && e.target.closest(SEARCH_TRIGGERS);
    if (!trigger) return;
    if (trigger.closest && trigger.closest('.Search__Close')) return;
    fireSearchOpened(trigger);
  }, true);

  window.addEventListener('klaviyoForms', function (e) {
    var type = e && e.detail && e.detail.type;
    if (type !== 'submit') return;
    track('email_submitted', { description: 'user submitted email' });
  });

  function isShopifyEmailForm(form) {
    if (!form) return false;
    var type = form.querySelector('input[name="form_type"]');
    if (type && type.value === 'customer') return true;
    return !!(form.querySelector('input[name="contact[email]"]') || form.querySelector('input[name="customer[email]"]'));
  }

  document.addEventListener('submit', function (e) {
    if (!isShopifyEmailForm(e.target)) return;
    try { sessionStorage.setItem(EMAIL_FLAG_KEY, '1'); } catch (err) {}
  }, true);

  function markLoginInitiated() {
    try { sessionStorage.setItem(LOGIN_FLAG_KEY, '1'); } catch (err) {}
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action) return;
    if (String(form.action).indexOf('/account/login') === -1) return;
    markLoginInitiated();
  }, true);

  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest && e.target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    if (href.indexOf('/account/login') !== -1
      || href.indexOf('customer_authentication/redirect') !== -1) {
      markLoginInitiated();
    }
  }, true);

  if (amp()) firePageLoadEvents();
  else window.addEventListener('dressx:amplitude-ready', firePageLoadEvents);

  flushPendingCartAdd();
})();
